exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag {\n  font-size:small;\n  padding: 0.3ex;\n  padding-left:1ex;\n  padding-right:1ex;\n  border: thin solid silver;\n  margin: 0.5ex;\n  border-radius: 8px;\n  font-weight: bold;\n  background-color: silver;\n  display: inline-block;\n  cursor: pointer\n}\n\nspan.selected {\n  background-color: #F5F583\n}\n\nspan.excluded {\n  background-color: lightcoral;\n}\n\nspan.family {\n  font-size: small\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/tag-filter/tag-filter.component.css
// module id = ../../../../../src/app/tag-filter/tag-filter.component.css
// module chunks = main